/**
 * Icon sizes, from the design system's own scale.
 *
 * Separate from `Icon.tsx` so that file exports only a component.
 */
export const ICON_SIZES = {
  sm: 'var(--icon-size-sm)',
  md: 'var(--icon-size-md)',
  lg: 'var(--icon-size-lg)',
} as const;

export type IconSize = keyof typeof ICON_SIZES;
